import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Shared guest auth CTAs — Join Now first, Sign In second.
 * Used in navbar (desktop, mobile bar, drawer) for consistent styling.
 */
const AuthNavButtons = ({
  layout = 'inline',
  compact = false,
  onNavigate,
  className = '',
  joinLabel = 'Join Now',
  signInLabel = 'Sign In',
  hideSignIn = false,
  hideJoin = false,
}) => {
  const wrapClass =
    layout === 'stack'
      ? 'flex flex-col gap-2.5 w-full'
      : 'flex items-center gap-2 shrink-0';

  const sizeClass = compact ? 'pf-btn-nav-compact' : '';
  const btnClass = [layout === 'stack' ? 'w-full justify-center' : '', sizeClass]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={`${wrapClass} ${className}`.trim()}>
      {!hideJoin && (
        <Link
          to="/signup"
          onClick={onNavigate}
          className={`pf-btn-primary pf-btn-nav no-underline ${btnClass}`.trim()}
        >
          {joinLabel}
        </Link>
      )}
      {!hideSignIn && (
        <Link
          to="/login"
          onClick={onNavigate}
          className={`pf-btn-secondary pf-btn-nav no-underline ${btnClass}`.trim()}
        >
          {signInLabel}
        </Link>
      )}
    </div>
  );
};

export default AuthNavButtons;
